import React from 'react';
import { Receipt } from 'lucide-react';
import { SaleResource } from '../types';
import SaleCard from './SaleCard';
import LoadingSpinner from './LoadingSpinner';

interface SalesListProps {
  sales: SaleResource[];
  loading: boolean;
  search: string;
}

const SalesList: React.FC<SalesListProps> = ({ sales, loading, search }) => {
  if (loading) {
    return (
      <div className="bg-white shadow rounded-lg p-8">
        <LoadingSpinner size="md" text="Loading sales..." />
      </div>
    );
  }

  if (sales.length === 0) {
    return (
      <div className="bg-white shadow rounded-lg p-8 text-center">
        <Receipt className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">No sales found</h3>
        <p className="mt-1 text-sm text-gray-500">
          {search ? `No sales match "${search}"` : 'This company has no sales yet.'}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
      {sales.map((sale) => (
        <SaleCard key={sale.id} sale={sale} />
      ))}
    </div>
  );
};

export default SalesList;
